import { useEffect, useState } from "react"
import { api, errorText } from "../api/client"
import type { PairInfo } from "../api/types"
import { Brand } from "./SignIn"

/** /pair?code=XXXX-XXXX — the connector opens this to be approved. The code is short-lived and single-use. */
export function PairPage() {
	const code = (new URLSearchParams(location.search).get("code") ?? "")
		.trim()
		.toUpperCase()
	const [info, setInfo] = useState<PairInfo | null>(null)
	const [err, setErr] = useState<string | null>(null)
	const [busy, setBusy] = useState(false)
	const [done, setDone] = useState(false)

	useEffect(() => {
		if (!code)
			return setErr("This link has no pairing code. Start the Walkie connector again.")
		api
			.pairInfo(code)
			.then(i => {
				setInfo(i)
				if (i.approved) setDone(true)
			})
			.catch(e => setErr(errorText(e)))
	}, [code])

	return (
		<div className="page">
			<div className="card">
				<div className="card-h">
					<Brand />
					<span className="dim">· pair a device</span>
				</div>
				{err && (
					<div className="form-error" role="alert">
						{err}
					</div>
				)}
				{!info && !err && <div className="loading-bar" />}
				{info && (
					<>
						<div className="blk">
							<div className="blk-row">
								<span className="lbl" style={{ width: 64 }}>
									Device
								</span>
								<b>{info.deviceName}</b>
							</div>
							<div className="blk-row">
								<span className="lbl" style={{ width: 64 }}>
									Platform
								</span>
								<span>{info.platform ?? "unknown"}</span>
							</div>
							<div className="blk-row">
								<span className="lbl" style={{ width: 64 }}>
									Code
								</span>
								<span className="mono">{code}</span>
							</div>
						</div>
						{done ? (
							<>
								<div style={{ color: "var(--ok)" }}>
									✓ Approved. The connector finishes setting up on its own.
								</div>
								<a
									className="btn"
									href="/"
									style={{ justifyContent: "center", textDecoration: "none" }}
								>
									Open Walkie
								</a>
							</>
						) : (
							<>
								<div style={{ color: "var(--warn)" }}>
									⚠ Only approve if you just started Walkie on that computer.
								</div>
								<button
									className="btn btn-primary btn-lg"
									style={{ justifyContent: "center" }}
									disabled={busy}
									onClick={async () => {
										setBusy(true)
										try {
											await api.approvePair(code)
											setDone(true)
										} catch (e) {
											setErr(errorText(e))
										} finally {
											setBusy(false)
										}
									}}
								>
									Approve this device
								</button>
							</>
						)}
					</>
				)}
			</div>
		</div>
	)
}
